/* eslint-disable jsx-a11y/img-redundant-alt */
import { formatTimestampToAgo } from "../../utils";
import React, { useState } from "react";
import SocialSettings from "./SocialSettings";
import { Button } from "..";
import {
  deleteSocialChannel,
  updateSocialChannel,
} from "@/store/app/app.actions";
import { connect, ConnectedProps } from "react-redux";
import { RootState } from "../../store";
import { setUserSocialChannels } from "@/store/app/app.slice";
import Modal from "../Modal/Modal";
import { AlertDialog } from "@/utils/ui/AlertDialog/AlertDialog";
import { updatePlaylist } from "@/store/app/app.actions";
import noImage from "../../assets/icons/svg/no-image.svg";
import { showSettings } from "@/utils/permission_wrapper";
import { Dropdown } from "react-bootstrap";
import { EllipsisVertical } from "lucide-react";
import DailymotionIcon from "../../assets/icons/svg/dailymotion-icon.svg?react";

const SocialCard = ({
  item,
  deleteSocialChannel,
  updatePlaylist,
  currentUser,
}: Props) => {
  const { name, mt, platform, image, customUrl, status, id, user, is_show } =
    item;
  const [isConfirmModalOpen, setConfirmModalOpen] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isValidImage, setIsValidImage] = useState(true);

  const handleUpdatePlaylist = () => {
    updatePlaylist(item.id);
  };
  const handleRemoveChannel = () => {
    deleteSocialChannel({ id: item.id });
    setConfirmModalOpen(false);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const handleShowConfirmModal = () => {
    setConfirmModalOpen(true);
  };

  const handleCloseConfirmModal = () => {
    setConfirmModalOpen(false);
  };

  const handleImageError = () => {
    setIsValidImage(false);
  };

  return (
    <>
      <div className="border-bottom mb-3 pb-3 d-flex gap-2">
        {platform === "dailymotion" ? (
          <i
            className="social-icon"
            style={{
              color: "grey",
              borderRadius: "2px 0 0 0",
              padding: "2px",
              marginRight: "10px",
            }}
          >
            <DailymotionIcon
              width={18}
              height={18}
              style={{
                color: "grey",
                borderRadius: "2px 0 0 0",
                padding: "2px",
              }}
            />
          </i>
        ) : (
          <i
            className={`bi bi-${platform} social-icon`}
            style={{
              color:
                platform === "facebook"
                  ? "grey"
                  : platform === "linkedin"
                  ? "grey"
                  : "grey",
            }}
          ></i>
        )}
        <div className="thumb">
          <div className="ratio ratio-1x1">
            <img
              className="object-fit-contain position-absolute top-50 start-50 translate-middle img-fluid"
              src={
                !isValidImage
                  ? noImage
                  : platform === "facebook"
                  ? `https://graph.facebook.com/${id}/picture?type=large`
                  : image || noImage
              }
              alt="Main"
              style={{ maxHeight: "100%", height: "auto" }}
              onError={handleImageError}
            />
          </div>
        </div>
        <div className="flex-grow-1">
          <div className="d-flex flex-row align-items-start">
            <div className="flex-grow-1">
              <h6
                className="line-clamp-2 pointer"
                onClick={() => {
                  if (
                    showSettings(
                      currentUser?.permissions,
                      item.business,
                      item.team,
                      item.service,
                      currentUser?.id === user
                    )
                  ) {
                    setModalOpen(true);
                  }
                }}
                style={{
                  cursor: !showSettings(
                    currentUser?.permissions,
                    item.business,
                    item.team,
                    item.service,
                    currentUser?.id === user
                  )
                    ? "not-allowed"
                    : "pointer",
                }}
              >
                {name}
              </h6>

              <span className="text-body-secondary d-block pb-2">
                {customUrl}
              </span>
              <span className="text-body-secondary d-block pb-2">
                Last Modified :{" "}
                {formatTimestampToAgo(mt) || formatTimestampToAgo(0)}
              </span>
              <span className="text-body-secondary d-block">
                Published Video : {item.publish_count || 0}
              </span>
            </div>
            <div className="btn btn-sm border pe-none">
              <span
                className={`${status === 1 ? "text-success" : "text-danger"}`}
              >
                {status === 1 ? "Active" : "Inactive"}
              </span>
            </div>
            {showSettings(
              currentUser?.permissions,
              item.business,
              item.team,
              item.service,
              currentUser?.id == user
            ) && (
              <div
                className="btn btn-sm btn-outline-primary H"
                onClick={() => {
                  setModalOpen(true);
                }}
              >
                <i className="bi bi-gear fs-5 pe-1"></i> Settings
              </div>
            )}
          </div>
        </div>
      </div>
      {isModalOpen && (
        <Modal
          isOpen={isModalOpen}
          onClose={handleModalClose}
          title={"Settings"}
          width="880px"
          footer={
            <div className="d-flex justify-content-end w-100 align-items-center position-relative">
              <Button
                className="text-white btn-primary"
                type="primary"
                onClick={() => {
                  const form = document.getElementById(
                    "socialSettingsForm"
                  ) as HTMLFormElement;
                  if (form) {
                    const submitEvent = new Event("submit", {
                      bubbles: true,
                      cancelable: true,
                    });
                    form.dispatchEvent(submitEvent);
                  }
                }}
              >
                Update
              </Button>
              <Dropdown align="end">
                <Dropdown.Toggle
                  variant=""
                  size="sm"
                  className="border-0 bg-transparent no-caret"
                  id="dropdown-menu-align-end"
                >
                  <EllipsisVertical className="pointer" />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item onClick={handleUpdatePlaylist}>
                    Update Playlist
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={handleShowConfirmModal}
                    className="text-danger"
                  >
                    Remove Channel
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          }
        >
          <SocialSettings item={item} handleClose={handleModalClose} />
        </Modal>
      )}
      {isConfirmModalOpen && (
        <AlertDialog
          isOpen={isConfirmModalOpen}
          onClose={handleCloseConfirmModal}
          onConfirm={handleRemoveChannel}
          title="ALERT!"
          message="Are you sure you want to remove this social channel?"
          confirmText="Confirm"
          cancelText="Cancel"
        />
      )}
    </>
  );
};

const mapState = (state: RootState) => ({
  socialChannels: state.app.userSocialChannels.socialChannelsList,
  currentUser: state.users.singleCurrentUser,
});

const mapDispatch = {
  deleteSocialChannel,
  setUserSocialChannels,
  updateSocialChannel,
  updatePlaylist,
};
const connector = connect(mapState, mapDispatch);

interface PropsItem {
  item: any;
}

type Props = ConnectedProps<typeof connector> & PropsItem;
export default connector(SocialCard);
